
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { OutletPresenter } from 'shared/presenters';
import { SchedulablePresenter } from 'shared/presenters/SchedulablePresenter';
import useGetPriceForBookingActivity, { UseGetPriceForBookingActivity } from 'state/useGetPriceForBookingActivity';
import { ActivityProps } from 'library/pages/Activity';
import useStoreMarketplaceReferrals from 'state/useStoreMarketplaceReferrals';
export type UseActivityPage = {
    outlet: OutletPresenter;
    activity: SchedulablePresenter;
    prices: UseGetPriceForBookingActivity;
};
/**
 * This hook has all the necessary logic for configuring the data or inserting extra functions
 * for rendering the Activity page.
 *
 * Add here any logic that has to be shared between the views.
 *
 * Components sharing this logic:
 * - Activity (library/pages/Activity)
 * - MockActivityPage
 */
const useActivityPage = ({ outlet: outletJSON, activity: activityJSON }: ActivityProps): UseActivityPage => {
    const outlet = new OutletPresenter(outletJSON);
    const activity = new SchedulablePresenter(activityJSON);
    useStoreMarketplaceReferrals();
    const prices = useGetPriceForBookingActivity({
        activity
    });
    return {
        outlet,
        activity,
        prices
    };
};
export default useActivityPage;

    async function __Next_Translate__getStaticProps__1961a27d759__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'library//Activity/useActivityPage',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1961a27d759__ as getStaticProps }
  